import { ITRequestFormValues } from './type';

export const initialValuesForm: ITRequestFormValues = {
  itReqType: null,
  simCardCreditLimit: null,
  emailIdLeft: null,
  emailIdRight: null,
  emailSignatureLeft: null,
  emailSignatureRight: null,
  document: null, // field do not store document itself, used just for validation to work
  isNewUser: 0,
  module: [],
  organization: null,
  projects: [],
  accountsModule: [],
  requiredRole: null,
  accessories: [],
  intCallsNumber: '',
  contactNo: '',
  remarks: '',
  recommendPackage: '',
  existingPackage: '',
  countryCode: '',
};
